import React, { useEffect, useState } from 'react';
import '../scss/archive_articles.scss';
import {Link, useLocation} from 'react-router-dom';


const Table_blogers = () => {
    const [data, setData] = useState([]);
    const [tags, setTags] = useState('');
    const [tag, setTag] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    let location = useLocation();
    let section = location.pathname.replace(/\//g, '');

    useEffect(() => {
        fetch( global.config.api + `/?method=articles_feed&category=${section}&page=1`)
            .then(response => response.json())
            .then(json => {
                if (json && json.feed) {
                    setData(json.feed);
                    setTags(json.tag_cloud);
                    // console.log('section', json.feed);
                } else {
                    console.error('Invalid data structure', json);
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [section, currentPage]);

    useEffect(() => {
        filterFeedItems(tag);
        //console.log('filterFeedItems', tag);
    }, [tag])


    const getPostThumbnail = (avatar) => {
        return avatar == '' ? '/wp-content/plugins/blog_tools/images/image_placeholder.png' : avatar;
    }


    const loadMoreButton = () => {
        // console.log('loadMoreButton' + currentPage);
        fetch( global.config.api + `/?method=articles_feed&category=${section}&page=${currentPage+1}`)
            .then(response => response.json())
            .then(json => {
                if (json && json.feed) {
                    // setMoreData(json.feed);
                    buildMoreArticles(json.feed);
                    setCurrentPage(currentPage + 1);
                    if(!json.there_is_more){
                       let more_button = document.querySelector("#load_more_button");
                        if (!more_button.classList.contains("hide_more_button")){
                            more_button.classList.add('hide_more_button');
                        }
                    }
                } else {
                    console.error('Invalid data structure', json);
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }

    const buildMoreArticles = (array) => {
        let feed = document.querySelector("#articles_block_feed");
        let html = 'Nothing to show';
        if(Array.isArray(array)) {
            html = '';
            array.forEach(function(item){
                // console.log(item.tags);
                html += `<div class="articles_block_feed_item loaded_item" data-tags=${JSON.stringify(item.tags)}>
                            <a class="articles_block_feed_item_link" href="#${location.pathname}/${ item.slug }">
                                <div class="articles_block_feed_item_wraper">
                                    <div class="articles_block_feed_item_wraper_box">
                                        <img src=${getPostThumbnail(item.avatar)} alt=${item.name}/>
                                    </div>
                                </div>
                                <div class="articles_block_feed_item_title">
                                    <div>
                                        <div class="articles_block_feed_item_title_name">
                                            ${item.name}
                                        </div>
                                        <div class="articles_block_feed_item_title_date">
                                            ${item.date}
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>`;
            })
        }
        feed.insertAdjacentHTML('beforeEnd', html);
        filterFeedItems(tag);
    }

    const getActiveButton = (name) => {
        return section == name ? ' active' : '';
    };

    const getArticlesTabs = (section) => {
        if (section == 'news'){
            return '';
        } else {
            return (
                <div className="articles_navigation">
                    <ul>
                        <li>
                            <Link to={"/guides"} className={'articles_navigation_guides' + `${getActiveButton('guides')}`} onClick={resetPageNumber}>Гайды</Link>
                        </li>
                        <li>
                            <Link to={"/wiki"} className={'articles_navigation_wiki' + `${getActiveButton('wiki')}`} onClick={resetPageNumber}>Wiki</Link>
                        </li>
                        <li>
                            <Link to={"/polls"} className={'articles_navigation_polls' + `${getActiveButton('polls')}`} onClick={resetPageNumber}>Пулы</Link>
                        </li>
                    </ul>
                </div>
            )
        }
    }

    const resetPageNumber = () => {
        setCurrentPage(1);
        const elements = document.getElementsByClassName('loaded_item');
        while(elements.length > 0){
            elements[0].parentNode.removeChild(elements[0]);
        }
        let more_button = document.getElementById('load_more_button');
        if (more_button.classList.contains("hide_more_button")){
            more_button.classList.remove('hide_more_button');
        }
        // console.log('reset ' + more_button.classList.contains("hide_more_button"));
    };

    const filterFeedItems = (filter) => {
        let all_items = document.getElementsByClassName('articles_block_feed_item');
        let count = 0;
        let display = 'none';
        Array.prototype.forEach.call(all_items, function(element) {
            let tags = JSON.parse(element.dataset.tags);
            if(tags.includes(filter) || filter == ''){
                element.classList.remove("filtered_tags");
                count++;
            } else {
                if(!element.classList.contains("filtered_tags")){
                    element.classList.add("filtered_tags");
                }
            }
        });

        display = count == 0 && all_items.length > 0? 'block' : 'none';
        console.log(count, display);
        document.getElementById('no_articles_to_show').style.display = display;
    }


    const handleTagsFilter = (e) => {

        let filter = e.target.getAttribute('data-tag');

        Array.prototype.forEach.call(document.getElementsByClassName('tags_cloud_wraper_item'), function(element) {
            let color = element.style.backgroundColor;
            let new_color = '';

            if(element.dataset.tag == filter && !e.target.classList.contains("filter_active")){
                setTag(filter);
                new_color = color.replace(/0\.125/g, '0.99');
                element.classList.add("filter_active");
            } else if(element.dataset.tag == filter && e.target.classList.contains("filter_active")){
                setTag('');
                element.classList.remove("filter_active");
                new_color = color.replace(/0\.99/g, '0.125');
            } else {
                element.classList.remove("filter_active");
                new_color = color.replace(/0\.99/g, '0.125');

            }
            element.style.backgroundColor = new_color;
        })

        // if(!e.target.classList.contains("filter_active")){
        //     e.target.classList.add("filter_active");
        //     new_color = color.replace(/0\.125/g, '0.99');
        // } else {
        //     e.target.classList.remove("filter_active");
        //     new_color = color.replace(/0\.99/g, '0.125');
        // }
        // e.target.style.backgroundColor = new_color;///tags_cloud_wraper_item



        // let all_tag_buttons = document.getElementsByClassName('tags_cloud_wraper_item');

        //console.log(filter);
    }


    const generateTags = (content) => {
        if (content) {
            return (
                <div className="tags_cloud_wraper">
                    {content.map((item, index) => (
                        <a className="tags_cloud_wraper_item outline_tag_button" data-tag={item.slug} onClick={handleTagsFilter}
                           style={{
                               borderColor: item.color,
                               color: item.color,
                               backgroundColor: `${item.color + '20'}`,
                           }}>
                            {item.name}
                        </a>
                    ))}
                </div>
            )
        } else {
            return '';
        }
    }

    return (
        <div>
            <div className='container'>
                <div>
                    {getArticlesTabs(section)}
                    <p className="articles_subtitle">Безопасность, хранение, майнинг и торговля криптовалют.</p>
                </div>
                <div className="tags_cloud">
                    {generateTags(tags)}
                </div>
                <div className='articles'>
                    <div className="articles_block">
                        <div id="articles_block_feed" className="articles_block_feed">
                            {data.map((item, index) => (
                                <div className="articles_block_feed_item" data-tags={JSON.stringify(item.tags)}>
                                <Link className="articles_block_feed_item_link" to={ item.slug }>
                                    <div className="articles_block_feed_item_wraper">
                                        <div className="articles_block_feed_item_wraper_box">
                                            <img src={getPostThumbnail(item.avatar)} alt={item.name}/>
                                        </div>
                                    </div>
                                    <div className="articles_block_feed_item_title">
                                        <div>
                                            <div className="articles_block_feed_item_title_name">
                                                {item.name}
                                            </div>
                                            <div className="articles_block_feed_item_title_date">
                                                {item.date}
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                </div>
                            ))}
                        </div>
                        <div id="no_articles_to_show" className="articles_block_feed_no_data">По данному тегу записей нет</div>
                    </div>
                    <button id="load_more_button" className="load_more" onClick={loadMoreButton} >Посмотреть еще </button>
                </div>
            </div>
        </div>
    );
};

export default Table_blogers;